"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { Button } from "@/components/button";

export default function IntroduceInfo() {
  const router = useRouter();
  return (
    <div
      className="
          relative
          mx-auto
          w-full
          max-w-7xl
          min-h-125
          sm:min-h-137.5
          md:min-h-150
          lg:h-140
          xl:h-150
          px-4
          sm:px-6
          lg:px-10
          py-8
          sm:py-10
          lg:py-14
          rounded-2xl
          sm:rounded-3xl
          lg:rounded-4xl
          overflow-hidden
          bg-[#F5F8FF]
        "
    >
      {/* Main content container */}
      <div className="relative z-10 h-full w-full">
        <div className="flex flex-col lg:flex-row h-full items-center justify-between gap-8 lg:gap-10">
          
          {/* Image section - Top on mobile, Right on desktop */}
          <div className="
            w-full
            lg:w-1/2
            order-1
            lg:order-2
            h-70
            sm:h-80
            md:h-87.5
            lg:h-full
            relative
            flex
            items-center
            justify-center
            lg:justify-end
            mt-4
            lg:mt-0
          ">
            <div className="relative w-full h-full max-w-125 mx-auto lg:mx-0">
              <Image
                src="/assets/website-landing.png"
                alt="Real Estate System"
                fill
                className="object-contain object-center lg:object-right"
                priority
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
            </div>
          </div>

          {/* Text content section - Bottom on mobile, Left on desktop */}
          <div className="
            w-full
            lg:w-1/2
            order-2
            lg:order-1
            flex
            flex-col
            justify-center
            text-center
            lg:text-right
            lg:items-end
            lg:pr-8
            xl:pr-12
          ">
            <div
              dir="rtl"
              className="
                w-full
                lg:max-w-135
                flex
                flex-col
                gap-4
                sm:gap-6
                lg:gap-8
                xl:gap-10
                text-gray-800
              "
            >
              <h1
                className="
                  text-2xl
                  sm:text-3xl
                  md:text-4xl
                  lg:text-[42px]
                  xl:text-[54px]
                  font-bold
                  leading-tight
                  sm:leading-snug
                  lg:leading-relaxed
                "
              >
                <span className="text-primary">مشاور؛</span>
                {" "}
                همیار هوشمند شما برای تحولی بزرگ در مدیریت املاک!
              </h1>

              <p
                className="
                  text-base
                  sm:text-lg
                  lg:text-xl
                  xl:text-2xl
                  leading-6
                  sm:leading-7
                  lg:leading-8
                  font-bold
                  text-gray-700
                  opacity-90
                "
              >
                جامع ترین و اختصاصی ترین سیستم CRM مشاورین املاک
              </p>

              <div className="flex flex-col gap-4 sm:gap-6">
                <div className="flex justify-center lg:justify-start mt-2 lg:mt-0">
                  <Button
                    variant="bare"
                    type="button"
                    text="جستجوی آگهی ــ ویژه جویندگان ملک"
                    className="
                      group
                      inline-flex
                      h-12
                      sm:h-14
                      cursor-pointer
                      items-center
                      justify-center
                      gap-3
                      rounded-full
                      bg-primary
                      px-8
                      sm:px-10
                      lg:px-12
                      text-sm
                      sm:text-base
                      lg:text-md
                      font-medium
                      text-white
                      transition-all
                      hover:bg-[#3730d8]
                      hover:shadow-xl
                      hover:shadow-primary/30
                      active:scale-95
                      w-full
                      sm:w-auto
                      max-w-87.5
                      lg:max-w-none
                    "
                    onClick={() =>
                      router.push(
                        `/advertisements-consultants/advertisements-filter/list`,
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}